import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils";
import { SYSTEM_ICON } from "../../../constants/entity-icons";
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "../../base/item/item";
import { appendDeletedSuffix, DELETED_ENTITY_CLASS, isAssigneeDeleted } from "../../../utils/deleted-entity-utils";
import { getSystemLogoUrl } from "../../../utils/system-utils";
export const SystemCard = /*#__PURE__*/ React.forwardRef(({ system, variant = "name-only", itemVariant = "default", size = "default", className, titleSlot, descriptionSlot, rightSlot }, ref)=>{
    const { t } = useTranslation();
    const logoUrl = getSystemLogoUrl(system);
    const isDeleted = isAssigneeDeleted(system);
    let secondaryText = null;
    if (variant === "with-category") {
        secondaryText = system.category;
    } else if (variant === "with-description") {
        secondaryText = system.description;
    }
    const showDescription = descriptionSlot ?? secondaryText;
    return /*#__PURE__*/ _jsxs(Item, {
        ref: ref,
        variant: itemVariant,
        size: size,
        className: cn(className, isDeleted && DELETED_ENTITY_CLASS),
        children: [
            /*#__PURE__*/ _jsx(ItemMedia, {
                variant: logoUrl ? "image" : "icon",
                children: logoUrl ? /*#__PURE__*/ _jsx("img", {
                    src: logoUrl,
                    alt: system.name,
                    className: "h-10 w-10 object-contain"
                }) : /*#__PURE__*/ _jsx(SYSTEM_ICON, {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ _jsxs(ItemContent, {
                children: [
                    /*#__PURE__*/ _jsx(ItemTitle, {
                        children: titleSlot ?? appendDeletedSuffix(system.name, isDeleted, t)
                    }),
                    showDescription && /*#__PURE__*/ _jsx(ItemDescription, {
                        children: showDescription
                    })
                ]
            }),
            rightSlot
        ]
    });
});
SystemCard.displayName = "SystemCard";

//# sourceMappingURL=system-card.js.map